import type { Thing, ThingType } from '/@/common/things/types'
import { createModal } from '/@/core/elements/modal'
import { useSessionState } from '/@/utils/persistence'

export interface ShareToFeedModalData {
  thing: Thing | null
}

const { api, component } = createModal<ShareToFeedModalData>(
  'ShareToFeedModal',
  () => import('./ShareToFeedModal.vue'),
  {
    thing: null,
  },
)

interface ThingState {
  id: string
  thingType: ThingType
}

const state = useSessionState('share-to-feed-state', {
  alreadyPrompted: [] as ThingState[],
})

export function maybeShowShareToFeedModal(data: ShareToFeedModalData) {
  const { thing } = data
  if (!thing) return

  if (
    state.alreadyPrompted.some(
      t => t.id === thing.id && t.thingType === thing.thingType,
    )
  )
    return

  state.alreadyPrompted.push({
    id: thing.id,
    thingType: thing.thingType,
  })
  api().show(data)
}

export const useShareToFeedModal = api
export default component
